import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import useFlash from "go-alert/AlertMessage";
import Header from "go-app/components/Header";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import RouteHistory from "go-core/utils/routeHistory";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { apiOrganization } from "../../../../../../../../../../services/Api/Organization/apiOrganization";
import { OrderApi, ProductStateApi } from "../../../../../../../../../../services/Api/Organization/types";
import OrderShipForm from "../../components/ShipForm/OrderShipForm";

interface MatchParams {
	orderId: string;
}

const OrganizationOrderOrdersShipPage = () => {
	const { t } = useTranslation();
	const organization = useSelector(selectOrganization);
	const history = useHistory();
	const { orderId } = useParams<MatchParams>();
	const [order, setOrder] = useState<OrderApi | undefined>();
	const { addFlash } = useFlash();
	const { handleChangeTabTitle } = useBrowserTabTitle();
	const [productStates, setProductStates] = useState<ProductStateApi[] | undefined>([]);

	useEffect(() => {
		handleInit();
	}, []);

	const handleInit = async () => {
		await fetchOrder();
		await fetchProductStates();
	};

	const fetchOrder = async () => {
		try {
			const params = { include: "all" };
			const res = await apiOrganization.getOrder(Number(orderId), params);
			setOrder(res);
			handleChangeTabTitle(`${res.document_number} | ${t("modules.order.header.ship.title")}`);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	const fetchProductStates = async () => {
		try {
			const params = {
				include: "volumes",
				stock_id: order?.stock?.id,
				product_ids: order?.items?.map((item) => item.product_id).join(","),
			};
			const res = await apiOrganization.getProductState(params);
			setProductStates(res);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	if (!order || !productStates) return <LoadingContainer />;

	const goBack = () => RouteHistory.goBack(history, `/${organization.id}/documents/sales/${order.id}`);

	return (
		<>
			<Header title={t("modules.order.header.ship.title")} back={goBack} />
			<OrderShipForm order={order} productStates={productStates} />
		</>
	);
};

export default OrganizationOrderOrdersShipPage;
